var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPajaro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.011,
    height: 81.011,
    viewBox: "0 0 81.011 81.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_34",
    "data-name": "Rect\\xE1ngulo 34",
    width: 81.011,
    height: 81.011,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_pajaro",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_134",
    "data-name": "Trazado 134",
    d: "M74.41,169.848a6.105,6.105,0,0,0,7.65-1.188q.6-.593,1.2-1.183c1.191-1.177,2.416-2.391,3.595-3.616a44.073,44.073,0,0,1-4.694-2.037Z",
    transform: "translate(-50.172 -108.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_135",
    "data-name": "Trazado 135",
    d: "M96.11,111.332h.119c5.339,0,10.8-6.2,12.915-8.876a5.659,5.659,0,0,0,.66-6.115,5.122,5.122,0,0,0-2.813-2.5l0-.007-.046,0a6.98,6.98,0,0,0-6.492,2.814,54.518,54.518,0,0,1-4.578,5.376q-2.931,2.929-5.861,5.86c1.822,2.247,3.869,3.408,6.095,3.446",
    transform: "translate(-60.637 -62.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_136",
    "data-name": "Trazado 136",
    d: "M146.84,57.078a7.508,7.508,0,0,0,5.339-.123c1.974-.905,3.45-2.9,4.386-5.929l.01,0a11.7,11.7,0,0,0-7.711-5.464,12.277,12.277,0,0,0-2.1-.246c.063.193.091,5.667.092,6.1,0,.453-.011,5.2-.015,5.66",
    transform: "translate(-98.693 -30.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    "data-name": "Trazado 137",
    d: "M121.122,46.892a5.527,5.527,0,0,0-1.453,4.074,1.961,1.961,0,0,0,1.552,1.934c.058.014.107.025.149.033.012-.053.024-.119.036-.2l.33-2.2,1.608,1.544a6.984,6.984,0,0,0,2.94,1.739V45.305c-.385.006-.771.013-1.155.013a5.43,5.43,0,0,0-4.008,1.574",
    transform: "translate(-80.522 -30.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M132.019,171.541q-.34,0-.661,0c-.018,1.471-.015,2.961-.011,4.408l0,1.627a2.244,2.244,0,0,0,.045.6,1.281,1.281,0,0,0,1.281.893,1.206,1.206,0,0,0,1.149-1.169c.03-2.555.03-4.549,0-6.393-.609.028-1.225.04-1.808.04",
    transform: "translate(-88.353 -114.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    "data-name": "Trazado 139",
    d: "M90.148,74.542a11.959,11.959,0,0,0-.336-2.5,9.819,9.819,0,0,1-4.718,4.943,8.732,8.732,0,0,1-3.63.761,10.635,10.635,0,0,1-2.622-.337c0,.017,0,.034,0,.051s0,.056,0,.089a7.6,7.6,0,0,1,3.038,3.121,7.966,7.966,0,0,1-.891,8.615c-2.882,3.656-8.608,9.753-14.725,9.754h-.158c-2.877-.05-5.46-1.436-7.692-4.114l-9.946,9.945-3.115,3.115-.018.018.02.019a6.223,6.223,0,0,0,6.824,1c.059-.028.133-.062.218-.1l9.812-10.165.773.424a40.043,40.043,0,0,0,7.145,2.948,3.086,3.086,0,0,1,.481.131l.026.008.176.046h0a7.809,7.809,0,0,0,1.156.154h.008A34.253,34.253,0,0,0,78,102.322a12.175,12.175,0,0,0,8.216-5.3c1.916-2.778,3.045-6.085,3.662-10.724a72.036,72.036,0,0,0,.283-11.479Z",
    transform: "translate(-30.675 -48.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M40.594,0A40.594,40.594,0,1,0,81.189,40.595,40.595,40.595,0,0,0,40.594,0M61.755,38.291c-.667,5.019-1.916,8.636-4.049,11.73a14.4,14.4,0,0,1-9.623,6.248h0l-.017,0-.017,0c.032,1.915.032,3.976,0,6.634a3.518,3.518,0,0,1-3.177,3.431,3.274,3.274,0,0,1-.388.023,3.609,3.609,0,0,1-3.365-2.5,4.078,4.078,0,0,1-.157-1.31l0-1.619c0-1.479-.009-3,.011-4.516A8.439,8.439,0,0,1,39.7,56.2l-.309-.082c-.061.062-.137.144-.2.211s-.13.141-.2.217c-1.313,1.38-2.685,2.737-4.013,4.048q-.6.589-1.191,1.18A8.411,8.411,0,0,1,22.6,62.864a8.524,8.524,0,0,1-9.2-1.45,2.059,2.059,0,0,1-.083-3.375l3.115-3.115q8.72-8.723,17.445-17.442a52.493,52.493,0,0,0,4.38-5.151A9.257,9.257,0,0,1,46.119,28.6c-.017-.93-.01-1.86,0-2.773A9.011,9.011,0,0,1,42.7,24.35a1.864,1.864,0,0,1-.251.2,2.5,2.5,0,0,1-2.035.205,4.264,4.264,0,0,1-3.3-4.1,7.509,7.509,0,0,1,7.763-8.025c.392,0,.784-.007,1.177-.014a21.1,21.1,0,0,1,4.874.3,13.815,13.815,0,0,1,11.12,13.246l.008.276a73.778,73.778,0,0,1-.3,11.849",
    transform: "translate(-0.272 0.197)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPajaro);
export default __webpack_public_path__ + "static/media/ico_pajaro.9974a280f2ce8d1b77d4da9c8fcd7707.svg";
export { ForwardRef as ReactComponent };